import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { navControlStyles, activeNavControlStyles } from 'components/navigation/common/styles'

export const NavigationLink = styled(NavLink)`
  ${navControlStyles}

  &.active {
    ${activeNavControlStyles}
  }
`
